import React, { Component } from 'react';
import { Table, Row, Col, FormControl, Button, Pagination} from 'react-bootstrap';
import AddUser from './AddUser.js';
import EditUser from './EditUser.js';
import ViewUser from './ViewUser.js';
import EditUserDetails from './EditUserDetails.js';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS
import _ from 'lodash';
import ShowModalPopUp from '../ShowModalPopUp';


export default class UserComponent extends Component {
	constructor(props){
		super(props)
		this.state=this.getinitialState(props) 
		}
		getinitialState(props){
			return {		
			term:'',
			activePage: 1,
			StatusObj:'',
			employeeId:'',
			name:'',
			searchFilter:false,
			showModal:false,
			selectedroles:[],
			selectedType:[],
			selectedcenterName:[],
			selectedprocessName:[],
			selectedregionName:[],
			selectedclientName:[] 
			};
	}
	UNSAFE_componentWillReceiveProps(nextProps){
		this.setState({tableData:nextProps.userData})
	}
	handleChange = (e) => {
		this.setState({[e.target.id]:e.target.value})	
	}
	openModal =() => {
		this.setState({ modalIsVisible: true, });
	}	
	closeModal=() =>{
		this.setState({ modalIsVisible: false, });
	}
	openModalEdit =(i) => {
		this.setState({['modalIsVisibleEdit'+i]: true, });
	}
	openModalView =(i) => {
		this.setState({['modalIsRead'+i]: true });
	}
	closeModalView =(i) => {
		this.setState({['modalIsRead'+i]: false });
	}
	openModalStatus =(i, prop) => {
		this.setState({['modalStatusEdit'+i]: true, StatusObj:prop});
	}
	closeModalStatus =(i) => {
		this.setState({['modalStatusEdit'+i]: false, });
	}
	
	closeModalEdit=(i) =>{
		this.setState({['modalIsVisibleEdit'+i]: false, });
	}
	openCalendarEdit =(i) => {
		this.setState({['modalCalendarEdit'+i]: true});
	}
	closeCalendarEdit =(i) => {
		this.setState({['modalCalendarEdit'+i]: false });
	}
	
	handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
	}
	handleDelete = (i,role_name) =>{
		const{StatusObj} = this.state;
		let obj ={"id": i,"status": StatusObj,"roleName":role_name}	
		this.props.action.UserStatusEdit(obj)
	} 
 
	handleSelectCenter = (e) => {
		this.setState({selectedcenterName: e});
		if(!_.isEqual(this.state.selectedcenterName, e)){               
			this.setState({selectedclientName:[], selectedprocessName:[]})
		}
	}
	handleSelectClient = (e) => {
		this.setState({selectedclientName: e});
		if(!_.isEqual(this.state.selectedclientName, e)){
			this.setState({selectedprocessName:[]})
		}
	}
	handleSelectProcess = (e) => {
		this.setState({selectedprocessName: e});
	} 
	handleSelectRegion = (e) => {
		this.setState({selectedregionName: e});
		if(!_.isEqual(this.state.selectedregionName, e)){               
			this.setState({selectedclientName:[], selectedprocessName:[], selectedcenterName:[]})
		}
	}
	handleSelectRoles = (e) => {
		this.setState({selectedroles: e});
	}
	handleSelectedType = (e) => {
		this.setState({selectedType: e});
	}
	addregions = () =>{
		const{inventoryData} = this.props;
		if(!_.isEmpty(inventoryData)){
		let regionNames = inventoryData 
		regionNames = _.uniqBy(regionNames, 'inventoryRegionId');
		return regionNames;
		}
	}
	addcenters = () => {
		const{selectedregionName} = this.state;
		let centerName;
		if(!_.isEmpty(selectedregionName)){
			centerName = selectedregionName.centers;
			centerName = _.uniqBy(centerName, 'inventoryCenterId');		
		}
		return centerName;
	}
	addclients= () => {
		const{selectedcenterName} = this.state;
		let clientName=[];
		if(!_.isEmpty(selectedcenterName)){	
			 clientName = selectedcenterName.clients  
			 clientName = _.uniqBy(clientName, 'inventoryClientId');		   
		}
		return clientName;
		
	}
	processNames = () => { 
		const{selectedclientName} = this.state;
		let processName=[];
		if(!_.isEmpty(selectedclientName) ){
		 processName = selectedclientName.processes
		 processName = _.uniqBy(processName, 'inventoryProcessId');	
		 return processName;
		}
	}
	searchFilter = () =>{
		const {employeeId, name, selectedclientName, selectedcenterName, selectedType, selectedprocessName, selectedregionName, selectedroles} = this.state
		let errorMessage='';
		let errorFlag = false;
		let showModal = false;
		let obj= {
			'employeeId':employeeId,
			'name':name,
			'roleId':selectedroles ? selectedroles.roleId : null,
			'type':!_.isEmpty(selectedType) ? selectedType : null,
			'inventoryRegionId':!_.isEmpty(selectedregionName) ? selectedregionName.inventoryRegionId : null,
			'inventoryCenterId':!_.isEmpty(selectedcenterName) ? selectedcenterName.inventoryCenterId : null,
			'inventoryClientId':!_.isEmpty(selectedclientName) ? selectedclientName.inventoryClientId : null,
			'inventoryProcessId':!_.isEmpty(selectedprocessName) ? selectedprocessName.inventoryProcessId : null
		}
		if(_.isEmpty(employeeId) && _.isEmpty(name) && _.isEmpty(selectedroles) && _.isEmpty(selectedregionName) && _.isEmpty(selectedcenterName) && _.isEmpty(selectedclientName) && _.isEmpty(selectedprocessName)){		
			showModal= true
			errorFlag = true
			errorMessage='Please Select any criteria'			
		} else if(!_.isEmpty(employeeId) && employeeId.length <3){	
			errorFlag = true
			showModal=true
			errorMessage='Please enter atleast 3 characters for employee id'			
		} else if(!_.isEmpty(name) && name.length <3){
			errorFlag = true
			showModal=true
			errorMessage='Please enter atleast 3 characters for name'			
		} else if(!_.isEmpty(selectedroles) && _.isEmpty(selectedregionName) && 
			_.isEmpty(selectedprocessName) && _.isEmpty(selectedclientName) && _.isEmpty(selectedcenterName)){
			errorFlag = true
			showModal=true
			errorMessage='Please Select roles, region, center, client, process'			
		} else if(!_.isEmpty(selectedregionName)){
			if(_.isEmpty(selectedcenterName) || _.isEmpty(selectedclientName) || _.isEmpty(selectedprocessName)) {
			errorFlag = true
			showModal= true
			errorMessage='Please Select region, center, client, process'
			} 
		} else {
			errorFlag = false
			showModal = false
			errorMessage = ''
		}
		if(errorFlag === false &&  showModal=== false){
			this.props.action.UserAction(obj)
		}
		this.setState({searchFilter:true, errorFlag:errorFlag, showModal:showModal, errorMessage:errorMessage})
	}
	resetFilter = () =>{
		this.setState(this.getinitialState())
	}
	onhide = () =>{
		this.setState({showModal:false})
	}

	
	render(){
		const{ tableData, employeeId,name, errorFlag, showModal, activePage, errorMessage, searchFilter }= this.state;	
		
		const{inventoryData, rolesData, categoryData, supervisorData, accessPermission, loginAction} = this.props;
		let permission;		
		if(!_.isEmpty(accessPermission)){
			permission=_.includes(accessPermission, 'WRITE')
		} 
		let tableValues = tableData
		const Per_Page=50;
		let totalPages;
		if(!_.isEmpty(tableValues)){
		 totalPages = Math.ceil(tableValues.length/Per_Page)
		}
		const startOffset = (this.state.activePage-1) * Per_Page;
		let startCount = 0;
		let items = [];
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
		}
		
		return(
				<div>
				<div className="firstDiv">
					<Row>
					<Col>
					User ID
					<FormControl
						placeholder="Employee Id"
						id='employeeId'
						aria-describedby="basic-addon1"
						onChange={(e) => this.handleChange(e)}
						value={employeeId}
					/></Col><Col>
					First Name
					<FormControl
						placeholder="First Name"
						id='name'
						aria-describedby="basic-addon1"
						onChange={(e) => this.handleChange(e)}
						value={name}
					/></Col><Col>
					Role
					<Picky keepOpen={false}
            value={this.state.selectedroles}
            options={this.props.rolesData}
            onChange={this.handleSelectRoles}
            open={false}
            valueKey="rolesName"
            labelKey="rolesName"
            multiple={false}
            includeSelectAll={true}
			includeFilter={true}
			clearFilterOnClose={true}
            placeholder='Roles'
            dropdownHeight={600}
          /></Col><Col>
						Type
					<Picky keepOpen={false}
            value={this.state.selectedType}
            options={['INACTIVE', 'ACTIVE']}
            onChange={this.handleSelectedType}
            open={false}
            //valueKey="firstName"
            //labelKey="firstName"
            multiple={false}
            includeSelectAll={true}
            includeFilter={false}
            placeholder='Type'
            dropdownHeight={600}
          /></Col>
					</Row><Row>
					<Col>
					Region
					<Picky keepOpen={false}
            value={this.state.selectedregionName}
            options={this.addregions()}
            onChange={this.handleSelectRegion}
            open={false}
            valueKey="inventoryRegionName"
            labelKey="inventoryRegionName"
            multiple={false}            
			includeFilter={true}
			clearFilterOnClose={true}
            placeholder='Select Region'
            dropdownHeight={600}
          /> </Col><Col>
					Center
					<Picky keepOpen={false}
						value={this.state.selectedcenterName}
						options={this.addcenters()}
						onChange={this.handleSelectCenter}
						open={false}
						valueKey="inventoryCenterName"
						labelKey="inventoryCenterName"
						multiple={false}  
						includeSelectAll={false}
						includeFilter={true}
						clearFilterOnClose={true}
						placeholder='Select Center'
						dropdownHeight={600}
            /></Col><Col>
					Client
					<Picky keepOpen={false}
						value={this.state.selectedclientName}
						options={this.addclients()}
						onChange={this.handleSelectClient}
						open={false}
						valueKey="inventoryClientName"
						labelKey="inventoryClientName"
						multiple={false}  
						includeSelectAll={false}
						includeFilter={true}
						clearFilterOnClose={true}
						placeholder='Select Client'
						dropdownHeight={600}
					/></Col><Col>
					Process
					<Picky keepOpen={false}
						value={this.state.selectedprocessName}
						options={this.processNames()}
						onChange={this.handleSelectProcess}
						open={false}
						valueKey="inventoryProcessName"
						labelKey="inventoryProcessName"
						multiple={false}  
						includeSelectAll={false}
						includeFilter={true}
						clearFilterOnClose={true}
						placeholder='Select Process Name'
						dropdownHeight={600}
           /></Col></Row>

				
				{(permission === true) ?
				<Button onClick={this.openModal} className='alignRight buttonwidth' size="md">ADD USER</Button> : null }
					{this.state.modalIsVisible ? 
				<AddUser inventory={inventoryData} rolesData={rolesData}  categoryData={categoryData}
					closeModal={this.closeModal} action={this.props.action} supervisorData={supervisorData} reportlist={this.props.reportlist}/> : null }
				</div>
				<Button onClick={this.resetFilter}className='alignRight buttonwidth' size="md">RESET</Button>
				<Button onClick={this.searchFilter}className='alignRight buttonwidth' size="md">SEARCH</Button>
				{(showModal === true) ? 
					(<ShowModalPopUp message={errorMessage} falseShowModalPopUp={this.onhide}/>) 
				: null} 
				{(searchFilter === true && errorFlag === false)?
				<div>
				<Table responsive>
					<thead>
						<th>USER ID</th>
						<th>NAME</th>
						<th>ROLE</th>
						<th>REGION</th>
						<th style={{width:'20%'}}>CENTER</th>
						{/* <th>CLIENT</th>
						<th>PROCESS</th> */}
						<th>VIEW USER</th>				
						{(permission === true) ?	<th>EDIT USER</th> : null}							
						{(permission === true) ? <th>ACTIVATE/<br/>
								DEACTIVATE USER</th> : null}								
					</thead>
					<tbody>
						{!_.isEmpty(tableValues) ?
						_.map(tableValues, (val, i)=>{
							if(i >= startOffset & startCount < Per_Page){
								startCount++;
								return(
									<tr>
									 <td className={(val.status === 'INACTIVE') ? 'disabled' : ''}>{val.employeeId}</td>
									<td className={(val.status === 'INACTIVE') ? 'disabled' : ''}>{val.firstName}</td>
									<td className={(val.status === 'INACTIVE') ? 'disabled' : ''}>{val.rolesName}</td>
									<td className={(val.status === 'INACTIVE') ? 'disabled' : ''}>{_.map(val.userInventoryMaps, (obj)=> { 
										return(<span>{obj.inventoryRegionName}<br/></span>)}) }</td>
									<td  className={(val.status === 'INACTIVE') ? 'disabled' : ''}>{_.map(val.userInventoryMaps, (obj, index1)=> { 
										return _.map(obj.userCenters, (obj1, index) =>{
										return(<span>{((index) ? ', ' : '') + obj1.inventoryCenterName}</span>)}) }) }
									</td>
									<td className={(val.status === 'INACTIVE') ? 'disabled' : ''}><i class='fas fa-eye' onClick={()=>this.openModalView(i)}/>
									{this.state['modalIsRead'+i] ?
									<ViewUser closeModal={()=>this.closeModalView(i)}  data={val}/> : null}
									</td>
									{(permission === true) ? 
									<td className={(val.status === 'INACTIVE') ? 'disabled' : ''}>
									<i className='fas fa-pen' onClick={()=>this.openModalEdit(i)} />
									{this.state['modalIsVisibleEdit'+i] ?  
									<EditUserDetails editOption={true} edit={_.cloneDeep(val)} inventory={inventoryData} rolesData={rolesData}  
										categoryData={categoryData} reportlist={this.props.reportlist} supervisorData={supervisorData}
										loginAction={loginAction}
										closeModal={()=>this.closeModalEdit(i)} action={this.props.action}/> : null }
									</td> : null}
								{(permission === true) ? 
									<td className={(loginAction.userName === val.employeeId) ? 'disabled' :'cant_be_disabled'}>
										{(val.status === 'INACTIVE') ? 
										<i class="fas fa-user-check" onClick={()=>this.openModalStatus(i, 'ACTIVE')}/> :
										<i class="fas fa-user-times" onClick={()=>this.openModalStatus(i, 'INACTIVE')}/>}
									{this.state['modalStatusEdit'+i] ?
										<EditUser closeModal={()=>this.closeModalStatus(i)} onCallBack={()=>this.handleDelete(val.id,val.rolesName)} status={this.state.StatusObj}/>
									: null}	
									</td>	: null}							

									</tr>);		
										
							}
														

						})
						:
						<tr><td colSpan={(permission === true) ? 8 : 5}>No Users Found</td></tr>
					}
					</tbody>
				</Table>
				
				<Pagination>
				<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
				<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
					{items[activePage-1]}
					{items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
					{items[activePage+1]}
					{/* {(activePage !== 1)  ? items[activePage-1] : null}
					{(activePage !== totalPages)  ?   items[totalPages-1]   : null } */}
				<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
				<Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
				</Pagination>
				</div>
				: null}
				</div>  );
					
		}

	}
